import {GitHubAvatar} from '@github-ui/github-avatar'
import {ChevronRightIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps} from '@primer/react'

import type {AutocompleteRepository} from '../../utils/copilot-chat-types'

interface RepositorySuggestionProps extends ActionListItemProps {
  repository: AutocompleteRepository
  isMultistep?: boolean
}

export function RepositorySuggestion({repository, isMultistep, ...props}: RepositorySuggestionProps) {
  return (
    <ActionList.Item key={repository.nameWithOwner} {...props}>
      <ActionList.LeadingVisual>
        <GitHubAvatar src={repository.ownerAvatar} alt="" size={16} square={repository.ownerType === 'Organization'} />
      </ActionList.LeadingVisual>
      {repository.nameWithOwner}
      {isMultistep && (
        <ActionList.TrailingVisual>
          <ChevronRightIcon />
        </ActionList.TrailingVisual>
      )}
    </ActionList.Item>
  )
}

try{ RepositorySuggestion.displayName ||= 'RepositorySuggestion' } catch {}